import Colors from "../../styles/colors";

const styles = {
  button: {
    color: Colors.Highnote.black,
    borderColor: Colors.Highnote.black,
    borderWidth: "3px",
    backgroundColor: Colors.Highnote.white,
    fontSize: "15px",
    fontWeight: "600",
    padding: "21px 32px",
    textTransform: "none",
    borderRadius: "30px",
    minWidth: "343px",
    marginBottom: "20px",
  },
  hover: {
    color: Colors.Highnote.black,
    borderColor: Colors.Highnote.black,
    borderWidth: "3px",
    backgroundColor: Colors.Highnote.offWhite,
  },
};

export default styles;
